import { ReactNode } from 'react';
import { useMaintenance } from '../../lib/MaintenanceContext';
import { useAuth } from '../../lib/AuthContext';
import { MaintenanceScreen } from './MaintenanceScreen';
import { GlobalLoader } from './global-loader';

interface MaintenanceGateProps {
    children: ReactNode;
}

export function MaintenanceGate({ children }: MaintenanceGateProps) {
    const { isBlocked, isLoading } = useMaintenance();
    const { loading: authLoading } = useAuth();

    // Wait for both auth and maintenance status to load
    if (authLoading || isLoading) {
        return <GlobalLoader text="Sprawdzanie dostępności..." />;
    }

    // Block non-admin users during maintenance
    if (isBlocked) {
        return <MaintenanceScreen />;
    }

    return <>{children}</>;
}
